import { REBALANCE_MAP_COLS } from '../../enums/';

export const columnGroups = {
  Date: [REBALANCE_MAP_COLS.DATE],
  Identifiers: [
    REBALANCE_MAP_COLS.TICKER,
    REBALANCE_MAP_COLS.COUNTRY,
    REBALANCE_MAP_COLS.CUSIP,
    REBALANCE_MAP_COLS.ISIN,
    REBALANCE_MAP_COLS.SEDOL,
    REBALANCE_MAP_COLS.BLOOMBERG_TICKER,
  ],
  Details: [
    REBALANCE_MAP_COLS.NAME,
    REBALANCE_MAP_COLS.PRICE,
    REBALANCE_MAP_COLS.SHARE_COUNT,
    REBALANCE_MAP_COLS.CURRENCY,
    REBALANCE_MAP_COLS.BROKER,
    REBALANCE_MAP_COLS.DESCRIPTION,
    REBALANCE_MAP_COLS.ASSET_TYPE,
    REBALANCE_MAP_COLS.MARKET_VALUE,
  ],
  Other: [
    REBALANCE_MAP_COLS.ASSET_ENTITY,
    REBALANCE_MAP_COLS.COST,
    REBALANCE_MAP_COLS.INVESTMENT_DATE,
    REBALANCE_MAP_COLS.UNREALIZED_GAIN_LOSS_BOOK,
    REBALANCE_MAP_COLS.ITD_PL,
    REBALANCE_MAP_COLS.YTD_PL,
    REBALANCE_MAP_COLS.QTD_PL,
    REBALANCE_MAP_COLS.MTD_PL,
    REBALANCE_MAP_COLS.DTD_PL,
    REBALANCE_MAP_COLS.COMMITED_AMOUNT,
    REBALANCE_MAP_COLS.CALLED_CAPITAL,
    REBALANCE_MAP_COLS.ITD_DISTRIBUTIONS,
    REBALANCE_MAP_COLS.ITD_RETURN_OF_CAPITAL,
    REBALANCE_MAP_COLS.INTERNAL_RATE_OF_RETURN,
  ],
};
